module.exports = __webpack_public_path__ + "img/onePair.2fdb9300.png";